module.exports = __webpack_public_path__ + "static/CDC-Logo-468e59ce4ac66aade6693f72ab1defd6.png";